const bgMargin = document.querySelector(".banner-margin");
// Define the animation using GSAP
const animation = gsap.to(bgMargin, {
    duration: 1.5,
    clipPath: "inset(16px)",
    ease: "power2.out",
    delay: 1,
  });

  // Create an Intersection Observer instance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Play the animation when the item enters the viewport
        animation.play();
      }
    });
  });

  // Observe the item
  observer.observe(document.querySelector(".banner-margin"));

const progressLine = document.querySelector('.inside-bar1');
var swiper = new Swiper(".mySwiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine.style.setProperty("--progress", progress);
        }
      }

});

const progressLine2 = document.querySelector('.inside-bar2');
var swiper2 = new Swiper(".mySwiper2", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine2.style.setProperty("--progress", progress);
        }
      }
});
const progressLine4 = document.querySelector('.inside-bar4');
var swiper4 = new Swiper(".mySwiper4", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine4.style.setProperty("--progress", progress);
        }
      }
});
const progressLine5 = document.querySelector('.inside-bar5');
var swiper5 = new Swiper(".mySwiper5", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine5.style.setProperty("--progress", progress);
        }
      }
});

const progressLine6 = document.querySelector('.inside-bar6');
var swiper6 = new Swiper(".mySwiper6", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine6.style.setProperty("--progress", progress);
        }
      }
});

const progressLine7 = document.querySelector('.inside-bar7');
var swiper7 = new Swiper(".mySwiper6", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine7.style.setProperty("--progress", progress);
        }
      }
});

var swiper3 = new Swiper(".mySwiper3", {
    loop: true,
    effect: "fade",
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});


const navLugar = document.querySelector('.nav-lugar');

const fixeItem = gsap.to(navLugar, {
    position: 'fixed',
    top: '35%',
    opacity: 1,
    duration: 1,
})
const opacityItem = gsap.to(navLugar, {
    opacity: 0,
})

  // Define ScrollTrigger for section 1
  ScrollTrigger.create({
    trigger: '.lugar', // Trigger element
    start: 'top-=100px top+=200', // Start 200 pixels before the section fully enters the viewport
    end: 'top+=200px center', // End when the section fully leaves the viewport
    animation: fixeItem,
    // markers: true,
  });

//   ScrollTrigger.create({
//     trigger: '.banner-paralax', // Trigger element
//     start: 'top-=100px top+=200', // Start 200 pixels before the section fully enters the viewport
//     end: 'bottom center', // End when the section fully leaves the viewport
//     markers: true,
//     onToggle: self => {
//         const element = document.querySelector('.nav-lugar');
//         if (self.isActive) {
//             console.log('entro');
//           gsap.set(element, {
//               opacity : 1,
//           })
//         } else {
//             console.log('saiu');
//             gsap.set(element, {
//               opacity : 0,
//           })
//         }
//     },
//   });


// Define ScrollTrigger for your element
$(".nav-lugar--title").get().forEach((e) => {
  console.log($(e));
    ScrollTrigger.create({
        trigger: $(e).attr('data-target'), // Your element's selector
        start: 'top-=100px top+=200', // Trigger when the top of the element reaches the bottom of the viewport
        end: 'bottom center', // Trigger when the bottom of the element reaches the top of the viewport
        onToggle: self => {
            const element = document.querySelector('.element' + $(e).attr('element'));
            if (self.isActive) {
              element.classList.add('active');
            } else {
              element.classList.remove('active');
            }
        },
    });
});
